module.exports = __webpack_public_path__ + "img/70f4.3fe1444f.jpg";